import { render, staticRenderFns } from "./RoomChannelsInput.vue?vue&type=template&id=72ecb8e8&lang=pug&"
import script from "./RoomChannelsInput.vue?vue&type=script&lang=js&"
export * from "./RoomChannelsInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "RoomChannelsInput.vue"
export default component.exports